/* ---------------------------------------------------------------------
Global Js
Target Browsers: All
------------------------------------------------------------------------ */
var FX = (function(FX, $) {

    $( function() {
        FX.Global.init();
    });
    $( function() {
        FX.MagnificPopup.init();
    });
    // $( function() {
    //     if ( FX.currentSite === 'tfa' ) {
    //     	FX.AnnouncementPopup.init();
    //     }
    // });
    $( function() {
        FX.LockVehicleBanner.init();
    });
    $( function() {
        FX.SlickSlider.init();
    });
    $( function() {
        FX.SwiperSlider.init();
    });
    $( function() {
        FX.Menu.init();
    });
    $( function() {
        FX.ResponsiveTables.init();
    });
    $( function() {
        FX.Social.init();
    });
    $( function() {
        FX.ImAHuman.init();
    });
    $( function() {
        FX.Affix.init();
    });
    $( function() {
        FX.Parallax.init();
    });
    $( function() {
        FX.Accordion.init();
    });
    $( function() {
        FX.TabsAndAccordion.init();
    });
    $( function() {
        FX.AddCheckoutInfo.init();
    })

    $( function() {
        $( '.customer-vehicles-form' ).each( function() {
            new FX.CustomerVehicleFields( $( this ) );
        });
	});

    $( window ).on( 'load', function() {
        FX.SmoothAnchors.init();
    });

    /**
     * Global
     *
     * @type {Object}
     */
    FX.Global = {

    	init: function() {

    	    window.onerror = FX.Global.error;

            /* Video category filtering */
			// $( 'select.video-cat' ).on( 'change', function() {
            //     var selectedCat     = $( this ).val(),
            //         $videoContainer = $( '.js-video-container' );
            //     $videoContainer.hide();
            //     if ( 'all' === selectedCat ) {
            //         $videoContainer.fadeIn();
            //     } else {
            //         $( '.' + selectedCat ).fadeIn();
            //     }
			// });

            let selects = $( 'select' ).not( '.custom-select' );
            if ( typeof selects.select2 === 'function' ) {
                selects.select2({
                    minimumResultsForSearch: 8
                });
            }

            $( '.shop-by-make' ).on( 'change', function() {
                document.location.href = $( this ).val();
			});

            /* to allow button text to appear over angle background */
            $( '.btn' ).not( '.btn-simple' ).wrapInner( '<span></span>' );

			$( '.readmore' ).click( function() {
                $( this ).parent().hide();
                $( '#' + $( this ).attr( 'data' ) ).show();
            });

            // Fitvids
            $( 'body' ).fitVids();

            $( '.mobile-shop-toggle' ).click( function() {
                $( '.mobile-shop-open-section' ).slideToggle( 'fast' );
                $( '.mobile-shop-toggle' ).toggleClass( 'mobile-shop-toggle-active' );
			});

            if ( $( '#signup-content' ).length ) {
                $( '#signup-content p.view' ).append( '<p>Once you\'ve logged in, please feel free to customize your password under the "Account Details" tab.</p>' );
            }

            $(document).on('focus keydown', '.select2-selection:not(.select2-selection--multiple)', function(ev) {
                if (ev.type === 'keydown' && ev.which < 32)
                    return;

                var target = jQuery(ev.target).closest('.select2-container');
                if (!target.length)
                    return;

                target = target.prev();
                target.select2('open');
            });

            $(document).on('select2:open', () => {
                document.querySelector('.select2-search__field').focus();
            });
    	},
        error: function( message, source, lineno, colno, error ) {
    	    var err        = {
    	        message: message,
                source: source,
                lineno: lineno,
                colno: colno,
                error: error,
                url: document.location.href
            };
    	    err            = JSON.stringify( err );
            window.onerror = null;
            const data     = {
                js_error: err
            };
            const options  = {
                endpoint: 'js_error',
                data: data,
                success: function() {window.onerror = FX.Global.error;},
            };
            FX.AJAX.callREST( options );
        },
        getCookie: function( name ) {
            var dc = document.cookie;
            var prefix = name + "=";
            var begin = dc.indexOf("; " + prefix);
            if (begin == -1) {
                begin = dc.indexOf(prefix);
                if (begin != 0) return null;
            }
            else
            {
                begin += 2;
                var end = document.cookie.indexOf(";", begin);
                if (end == -1) {
                end = dc.length;
                }
            }
            // because unescape has been deprecated, replaced with decodeURI
            //return unescape(dc.substring(begin + prefix.length, end));
            return decodeURI(dc.substring(begin + prefix.length, end));
        }
    };

    /**
     * MagnificPopup - https://dimsemenov.com/plugins/magnific-popup/documentation.html
     *
     * @type {Object}
     */
    FX.MagnificPopup = {

    	init: function() {

            $( '.video-popup' ).magnificPopup({
                type:'iframe'
            });

            $( '.product-page-main-img' ).magnificPopup({
                delegate: 'a',
                type: 'image',
                tLoading: 'Loading image #%curr%...',
                mainClass: 'mfp-img-mobile',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                },
                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                }
            });

            $( '.product-page-main-img__zoom' ).on( 'click', function() {
				$( '.product-page-main-img' ).find( '.slick-current a' ).click();
			});

            $( '.html-popup, .social-popup-link' ).magnificPopup({
                type:'inline'
            });

            $( '.video-listing' ).magnificPopup({
                delegate: 'a',
                type: 'iframe',
                gallery: {
                    enabled: true,
                }
            });
        }
    };

    FX.AnnouncementPopup = {
        init: function() {
            if ( undefined === Cookies.get( 'tf_popup_close' ) ) {
                // $( '#announcement-popup' ).slideDown();
                $('#announcement-popup').css('opacity', 1).css('pointer-events', 'all');
            } else {
                $('#announcement-popup').remove();
            }
            $( '.announcement-popup-close' ).click( function() {
                // $( '#announcement-popup' ).slideUp();
                // $('#announcement-popup').css('opacity', 0);
                $('#announcement-popup').remove();
                Cookies.set( 'tf_popup_close', 1 );
            });
        }
    };

    FX.LockVehicleBanner = {
        init: function() {
            if ( ! Cookies.get( 'user_vehicle' ) ) {
                Cookies.set( 'lock_vehicle_shown', 1 );
                if ( ! Cookies.get( 'user_vehicle' ) ) {
                    // Only show if user has not filtered by vehicle already
                    $( '.lock-vehicle-banner' ).addClass( 'lock-vehicle-banner-on' );
                }
            }
        }
    };

	/**
     * Slider/Carousel
     *
     * @type {Object}
     */
    FX.SlickSlider = {

        init: function() {

            let $bannerSlider = $( '.banner-slider' ),
                autoPlaySpeedDefault = 3000;

            $bannerSlider
                .on( 'init', function( e, slick ) {
                    let slideTime = $( e.target ).find( 'div[data-slick-index="0"] .banner-slider-item' ).data( 'time' );
                    if ( ! slideTime ) {
                        slideTime = autoPlaySpeedDefault;
                    }
                    slick.options.autoplaySpeed = slideTime;
                })
                .on( 'afterChange', function( e, slick, currentSlide ) {
                    let slideTime = $( e.target ).find( 'div[data-slick-index="'+ currentSlide + '"] .banner-slider-item' ).data( 'time' );
                    if ( ! slideTime ) {
                        slideTime = autoPlaySpeedDefault;
                    }
                    $bannerSlider.slick( 'setOption', 'autoplaySpeed', slideTime );
                });
            $bannerSlider.slick({
                dots: true,
                prevArrow: '<button type="button" class="slick-prev"><span class="flaticon-back"></span></button>',
                nextArrow: '<button type="button" class="slick-next"><span class="flaticon-forward"></span></button>',
                autoplay: true,
                autoplaySpeed: autoPlaySpeedDefault,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            arrows: false
                        }
					}
                ]
            });

            $( '.slider-about' ).slick({
                dots: true,
                prevArrow: '<button type="button" class="slick-prev"><span class="flaticon-back"></span></button>',
                nextArrow: '<button type="button" class="slick-next"><span class="flaticon-forward"></span></button>',
            });

            FX.SlickSlider.homepageMobileProductSlider = false;
            $( window ).on( 'resize', function() {
                var mq = window.matchMedia( '(max-width: 1024px)' );
                if ( mq.matches && FX.SlickSlider.homepageMobileProductSlider === false ) {
                    $( '.product-slide-1' ).slick({
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: false,
                        prevArrow: '<button type="button" class="slick-prev"><span class="flaticon-back"></span></button>',
                        nextArrow: '<button type="button" class="slick-next"><span class="flaticon-forward"></span></button>',
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 599,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    });
                    FX.SlickSlider.homepageMobileProductSlider = true;
                } else if ( ! mq.matches && FX.SlickSlider.homepageMobileProductSlider === true ) {
                    $( '.product-slide-1' ).slick( 'unslick' );
                    FX.SlickSlider.homepageMobileProductSlider = false;
                }//end if
			});
            $( window ).resize();

            $( '.slider-small' ).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            });

            $( '.slide-for-mobile' ).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                prevArrow: '<button type="button" class="slick-prev"><span class="flaticon-back"></span></button>',
                nextArrow: '<button type="button" class="slick-next"><span class="flaticon-forward"></span></button>'
            });

			/* Preloader */
			$( '.js-slider-has-preloader' ).on( 'init', function( event, slick ) {
                $( '.js-slider-has-preloader' ).addClass( 'js-slider-has-preloader-init' );
			});
        }
    };

    /**
     * Swiper Slider
     *
     * @type {Object}
     */
        FX.SwiperSlider = {
            init: function () {
                new Swiper('.swiper-container', {
                    slidesPerView: 1,
                    spaceBetween: 25,
                    loop: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        1440: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        480: {
                            slidesPerView: 1,
                            spaceBetween: 5,
                        }
                    }
                });
            }
        };

    /**
     * Menu functionality
     */
    FX.Menu = {
        activateMegamenu: true,
        init: function() {
            if( $('.js-no-submenu').length ) {
                return;
            } else {
                this.activateMegamenu = true;
                // if ( Cookies.get( 'user_vehicle' ) && $( '.menu > .js-respect-selected-vehicle > a, .js-respect-selected-vehicle > li > a' ).length > 0 ) {
                //     this.activateMegamenu = false;
                //     $( '.menu > .js-respect-selected-vehicle > a, .js-respect-selected-vehicle > li > a' ).not( '.no-mobile-child' ).each( function() {
                //         var $this = $( this ),
                //             url = $this.attr( 'href' );
                //         $( this ).attr( 'href', FX.Menu.updateUrlParameter( url, 'vehicle-filtered', 'true' ) );
                //     });
                // }
                if ( window.matchMedia( '(max-width: 1200px)' ).matches ) {
                    this.mobileMenu();
                } else {
                    this.desktopMenu();
                }
            }
        },

        desktopMenu: function() {
            $( '.sub-menu-trigger' ).off( 'click' );
            if ( this.activateMegamenu ) {
                $( '.sub-menu-trigger' ).click( function(e) {
                    if ( $( this ).siblings().length ){ 
                        let $this = $( this ),
                            $parent = $( this ).parent( '.menu-item' );
                        e.preventDefault();
                        $this.siblings().find( '.menu-item.has-children' ).removeClass( 'active' );
                        $parent.siblings().removeClass( 'active' );
                        $this.parents( '.menu-item.has-children' ).siblings().find( '.menu-item.has-children' ).removeClass( 'active' );
                        $parent.toggleClass( 'active' );
                    }
                });
                // Close megamenu if user clicks off of it
                $( document ).click( function(e) {
                    if ( $( e.target ).closest( '.nav-primary' ).length === 0 ) {
                        $( '.menu-item.has-children' ).removeClass( 'active' );
                    }
                });
            }
        },

        mobileMenu: function() {
            $( '.submenu-back-button, .sub-menu-toggle, .mobile-search, .menu-icon, .menu-close' ).off( 'click' );
            if ( this.activateMegamenu ) {
                $( '.nav-primary li.has-children > a' ).not( '.no-mobile-child' ).after( '<span class="sub-menu-toggle icon-arrow-down hidden-lg"></span>' );
                $( 'ul.sub-menu' ).append( '<li class="menu-item hidden-lg submenu-back-button"><span class="flaticon-back"></span>Back</li>' );
                $( '.submenu-back-button' ).on( 'click', FX.Menu.closeSubMenu );
                $( '.sub-menu-toggle' ).on( 'click', function() {
                    if ( $( this ).siblings().length ){ 
                        var $this   = $( this ),
                            $parent = $this.closest( 'li' ),
                            $wrap   = $parent.find( '> .sub-menu' );
                        $wrap.slideToggle();
                        $this.toggleClass( 'js-clicked' );
                        $this.siblings( 'a' ).toggleClass( 'js-toggled' );
                        FX.Menu.openSubMenu( $parent );
                        $parent.addClass( 'active' );
                    }
                });
            } else {
                $( '.sub-menu-toggle, .submenu-back-button' ).remove();
            }
            $( '.mobile-search' ).click( function( e ) {
                e.preventDefault();
                $searchField = $( '#mobile-search' );
                if ( $searchField.is( ':visible' ) ) {
                    $searchField.slideUp();
                } else {
                    $searchField.slideDown();
                }
            });
            $( '.menu-icon' ).click( function() {
                $( '.page-header .nav-primary' ).toggle( 'slide' );
                $( 'body' ).addClass( 'nav-slide' );
                $( '.menu-icon' ).css( 'display','none' );
            });
            $( '.menu-close' ).click( function() {
                $( '.page-header .nav-primary' ).toggle( 'slide' );
                $( 'body' ).removeClass( 'nav-slide' );
                $( '.menu-icon' ).css( 'display','block' );
                $( '.submenu-hidden' ).removeClass( 'submenu-hidden' );
                $( '.submenu-back-button' ).click();
            });
        },

        openSubMenu: function( $parent ) {
            let $parents_parent     = $parent.parent(),
                $siblings           = $parent.siblings(),
                $parent_arrow       = $parent.children( 'span' ),
                $previous_menu_item = $parents_parent.closest( '.has-children.active' );
            $parents_parent.find( '.submenu-hidden' ).removeClass( 'submenu-hidden' );
            if ( $previous_menu_item.length > 0 ) {
                $previous_menu_item.children( 'a' ).addClass( 'sub-submenu-hidden' );
            }
            $siblings.addClass( 'submenu-hidden' );
            $parent_arrow.addClass( 'submenu-hidden' );
        },

        closeSubMenu: function(e) {
            let $this            = $( this ),
                $submenu_to_hide = $this.closest( 'ul' ),
                $parent_submenu  = $submenu_to_hide.parent().closest( 'ul' ),
                $parent_items    = $parent_submenu.children();
            $parent_items.removeClass( 'submenu-hidden' ).removeClass( 'active' );
            $parent_items.children( '.js-toggled' ).toggleClass( 'js-toggled' ).siblings( 'span' ).removeClass( 'submenu-hidden' ).toggleClass( 'js-clicked' );
            $parent_submenu.parent().closest( 'li' ).children( '.sub-submenu-hidden' ).removeClass( 'sub-submenu-hidden' );
        },

        // from: https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
        updateUrlParameter: function(uri, key, value) {
            // remove the hash part before operating on the uri
            var i = uri.indexOf('#');
            var hash = i === -1 ? ''  : uri.substr(i);
            uri = i === -1 ? uri : uri.substr(0, i);

            var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
            var separator = uri.indexOf('?') !== -1 ? "&" : "?";

            if (!value) {
              // remove key-value pair if value is empty
              uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
              if (uri.slice(-1) === '?') {
                uri = uri.slice(0, -1);
              }
              // replace first occurrence of & by ? if no ? is present
              if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
            } else if (uri.match(re)) {
              uri = uri.replace(re, '$1' + key + "=" + value + '$2');
            } else {
              uri = uri + separator + key + "=" + value;
            }
            return uri + hash;
          }
    };

    /**
     * Responsive Tables
     *
     * @type {Object}
     */
    FX.ResponsiveTables = {

        init: function() {

            // Add wrappers to table
            // - change ".page-content table" to appropriate class per project
            $( ".page-content table" ).wrap( "<div class='table-wrap-outer' style='position: relative'><div class='table-wrap-inner' style='overflow: auto'></div></div>" );

            // Make table draggable
            var mx = 0;

            $( ".table-wrap-inner" ).on({
                mousemove: function(e) {
                    var mx2 = e.pageX - this.offsetLeft;
                    if (mx) {
                        this.scrollLeft = this.sx + mx - mx2;
                    }
                },
                mousedown: function(e) {
                    this.sx = this.scrollLeft;
                    mx      = e.pageX - this.offsetLeft;
                }
            });

            $( document ).on( 'mouseup', function(){
                mx = 0;
            });

            // Add class if table is wider than parent
            $( '.table-wrap-outer' ).find( '.table-wrap-inner table' ).each( function() {
                var $table   = $( this ),
                $table_outer = $table.closest( '.table-wrap-outer' );
                if ($table.width() > $table_outer.width()) {
                    $table_outer.addClass( 'js-table-is-overflowing' );
                    // - change ".page-content table" to appropriate class per project
                    $( ".page-content table" ).before( "<div class='js-table-fade' style='position: absolute; right: 0; top: 0; height: 100%; width: 40px; background: -moz-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=1; )'></div>" );
                }
            });

        }
    };

    /**
     * Custom Social Share icons open windows
     * Generate URLs, place in a tag and use class - example: https://github.com/bradvin/social-share-urls
     *
     * @type {Object}
     */
    FX.Social = {

        init: function() {
            $( ".js-social-share" ).on( "click", this.open );
        },

        open: function(event) {
			event.preventDefault();
			FX.Social.windowPopup( $( this ).attr( "href" ), 500, 300 );
        },

        windowPopup: function (url, width, height) {
            var left = (screen.width / 2) - (width / 2),
                top  = (screen.height / 2) - (height / 2);
            window.open(
                url,
                "",
                "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
            );
        }
    };

    /**
     * ImAHuman
     * Hidden Captchas for forms
     *
     * @type {Object}
     */
    FX.ImAHuman = {

        num: "0xFF9481",
        forms: void 0,

        init: function() {
            this.setup();
        },

        setup: function() {
            this.forms = document.getElementsByTagName( "form" );
            this.bind();
        },

        bind: function() {
            for (var i = 0; this.forms.length > i; i++) {
                $( this.forms[i] ).on( "focus click", this.markAsHuman );
            }
        },

        markAsHuman: function() {
            $( this ).find( '.imahuman, [name="imahuman"]' ).attr( "value", parseInt( FX.ImAHuman.num, 16 ) );
        }
    };

    /**
     * Affix
     * Fixes sticky items on scroll
     *
     * @type {Object}
     */
    FX.Affix = {

        windowHeight: 0,
        fixPoint: 0,

        init: function() {
            this.windowHeight = $( window ).height();
            $masthead         = $( '.masthead' );
            if ( $masthead.length > 0) {
                this.fixPoint = $( '#page-header' ).height() + $masthead.height();
            } else {
                this.fixPoint = $( '#page-header' ).height() + 15;
            }
            this.bind();
        },

        bind: function(e) {
            $( window ).on( 'scroll', this.scroll );
            $( window ).on( 'resize', this.updateWindowHeight );
        },

        scroll: function(e) {
            var scrolltop = $( this ).scrollTop(),
                fixPoint  = FX.Affix.fixPoint,
                $body     = $( 'body' );

            if ($body.hasClass( 'affix-head' )) {
                fixPoint = fixPoint - 140;
            }

            if (scrolltop >= fixPoint) {
                $body.addClass( 'affix-head' );
            } else {
                $body.removeClass( 'affix-head' );
            }
        },

        updateWindowHeight: function(e) {
            FX.Affix.windowHeight = $( window ).height();
        }
    };

    /**
     * FX.Parallax
     * Parallax effect for images
     *
     * @type {Object}
     */
    FX.Parallax = {

        init: function() {
            this.bind();
        },

        bind: function() {
            $( window ).scroll( this.scroll );
        },

        scroll: function(e) {
            $( '.js-parallax' ).each(
                function(){
					var $this = $( this ),
                    $speed    = $this.data( 'speed' ) || 6,
                    $window   = $( window ),
                    yPos      = -($window.scrollTop() / $speed),
                    coords    = 'center ' + yPos + 'px';
					$this.css( { backgroundPosition: coords } );
				}
            );
        }
    };

    /**
     * FX.SmoothAnchors
     * Smoothly Scroll to Anchor ID
     *
     * @type {Object}
     */
    FX.SmoothAnchors = {

        exclude: [ '#', '#checkout-issues-form-container' ],

        init: function() {
            this.hash = window.location.hash;
            if ( this.hash != '' && this.hash !== '#register' ) { // Don't trigger on Login/Register page
                this.scrollToSmooth( this.hash );
            }
            this.bind();
        },

        bind: function() {
            $( 'a[href^="#"]' ).on( 'click', $.proxy( this.onClick, this ) );
        },

        onClick: function(event) {
            event.preventDefault();
            var target = $( event.currentTarget ).attr( 'href' );
            if ( this.exclude.includes( target ) ) {
                return;
            }
            this.scrollToSmooth( target );
        },

        scrollToSmooth: function(target) {
            var $target      = $( target );
            $target          = ($target.length) ? $target : $( this.hash );
            var headerHeight = 0; // TODO: if using sticky header change 0 to $('#page-header').outerHeight(true)
            if( target == "#js-jump" ){
                headerHeight = $('.sticky-header').outerHeight(true);
            }
            if ($target.length) {
                var targetOffset = $target.offset().top - headerHeight;
                $( 'html,body' ).animate( {scrollTop: targetOffset}, 600 );
                return false;
            }
        }
    };

    /**
     * Combined Tabs and Accordion
     *
     * @type {Object}
     */
    FX.TabsAndAccordion = {
        init: function() {
            this.bind();
        },

        bind: function() {
            $( '.js-tabs' ).on( 'click touchstart', 'a', this.changeVisibility );
            $( '.combined-accordion-toggle' ).on( 'click touchstart', this.changeVisibility );
        },

        changeVisibility: function() {
            const $this = $( this ),
                  isTabs = window.matchMedia( '(min-width: 768px)' ).matches ? true : false;
            var $tab, $contentDiv, $accordion;
            // $this is either a tab button or an accordion-toggle
            if ( $this.parent().parent().hasClass( 'js-tabs' ) ) {
                // This is a tab, initialize stuff from it
                $tab        = $this,
                $contentDiv = $( $this.attr( 'href' ) ),
                $accordion  = $contentDiv.prev();
            } else {
                // This is an accordion, initialize stuff from it
                $accordion  = $this,
                $contentDiv = $accordion.next(),
                $tab        = $( '.tabs li a[href="#' + $contentDiv.attr( 'id' ) + '"]' );
            }
            // Set tab active
            $tab.parent().addClass( 'active' ).siblings().removeClass( 'active' );
            // Set accordion expanded
            var alreadyExpanded = $accordion.hasClass( 'expanded' );
            $( '.combined-accordion-toggle' ).removeClass( 'expanded' );
            if ( ! alreadyExpanded ) {
                $accordion.addClass( 'expanded' );
            }
            // Display content
            if ( isTabs ) {
                $( '.tab-content' ).removeClass( 'active' ).hide();
                $contentDiv.addClass( 'active' ).show();
            } else {
                $( '.combined-accordion-content' ).removeClass( 'expanded' ).slideUp();
                if ( ! alreadyExpanded ) {
                    $contentDiv.addClass( 'expanded' ).slideDown();
                }
            }
            return false;
        }
    };

    /**
     * Accordion Content
     *
     * @type {Object}
     */

    FX.Accordion = {
        init: function() {
			this.bind();
            $( '.accordion-content' ).hide();
		},

		bind: function() {
			$( 'body' ).on( 'toggle-panel', '.accordion-toggle', this.togglePanel );
			$( '.accordion-toggle' ).click( this.togglePanel );
		},

		togglePanel: function() {
            const $this   = $( this );
            const $target = $this.next();

            if ($this.hasClass( 'expanded' )) {
                $this.removeClass( 'expanded' );
                $target.removeClass( 'expanded' ).slideUp();
            } else {
                $( '.accordion-content' ).removeClass( 'expanded' ).slideUp();
                $( '.accordion-toggle' ).removeClass( 'expanded' );
                $this.addClass( 'expanded' );
                $target.addClass( 'expanded' ).slideDown();
            }
		}
    };

    FX.CustomerVehicleFields = Class.extend({
        rows: 1,
        maxRows: 10,
        init: function( $el ) {
            this.$el = $el;
            this.$el.find( '.js-add-another' ).on( 'click', $.proxy( this.addAnother, this ) );
            this.$el.find( '.js-remove-one' ).on( 'click', $.proxy( this.removeOne, this ) );
            this.$el.find( '.js-make' ).on( 'change', this.makeChanged );
            this.$el.find( '.js-model' ).on( 'change', this.modelChanged );
            this.rows = this.maxRows - this.$el.find( '.js-vehicle-row.hidden' ).length;
            this.updateActionButtons();
        },
        addAnother: function() {
            this.rows++;
            if ( this.rows <= this.maxRows ) {
                this.$el.find( '.js-vehicle-row-' + this.rows ).removeClass( 'hidden' );
                this.updateActionButtons();
            }
        },
        removeOne: function() {
            let $row = this.$el.find( '.js-vehicle-row-' + this.rows );
            $row.addClass( 'hidden' );
            // Clear value of fields in this row
            $row.find( '.js-make' ).val( null ).trigger( 'change' );
            $row.find( '.js-model, .js-year' ).prop( 'disabled', true );
            this.rows--;
            this.updateActionButtons();
        },
        makeChanged: function() {
            let $this   = $( this ),
                options = [];
            if ( $this.val() ) {
                options = vehicleMakesModels[ $this.val() ];
            }
            let option_string = '<option></option>';
            for ( var model in options ) {
                option_string += '<option value="' + model + '">' + model + '</option>';
            }
            let $sibs = $this.parent().siblings();
            $sibs.children( '.js-model' ).prop( 'disabled', false ).html( option_string );
            $sibs.children( '.js-year' ).empty().prop( 'disabled', true );
        },
        modelChanged: function() {
            let $this   = $( this ),
                make    = $this.parent().siblings().children( '.js-make' ).val(),
                options = [];
            if ( $this.val() ) {
                options = vehicleMakesModels[ make ][ $this.val() ];
            }
            let option_string = '<option></option>';
            let num_options   = options.length;
            for ( let i = 0; i < num_options; i++ ) {
                option_string += '<option value="' + options[i] + '">' + options[i] + '</option>';
            }
            $this.parent().siblings().children( '.js-year' ).prop( 'disabled', false ).html( option_string );
        },
        updateActionButtons: function() {
            if ( this.rows === this.maxRows ) {
                this.$el.find( '.js-vehicle-actions--add' ).addClass( 'hidden' );
            } else {
                this.$el.find( '.js-vehicle-actions--add' ).removeClass( 'hidden' );
            }
            if ( 1 === this.rows ) {
                this.$el.find( '.js-vehicle-actions--remove' ).addClass( 'hidden' );
            } else {
                this.$el.find( '.js-vehicle-actions--remove' ).removeClass( 'hidden' );
            }
        }
    });

    /**
     * AJAX helper object
     */
    FX.AJAX = {
        callREST: function(options) {
            let defaultOptions = {
                endpoint: '',
                data: {},
                method: 'POST',
                success: function(){},
                error: function(){},
            };
            options = $.extend({}, defaultOptions, options);
			const settings = {
				data: options.data,
				type: options.method,
                success: options.success,
                error: options.error
			};
			$.ajax('/wp-json/emb/v1/' + options.endpoint + '/?_wpnonce=' + FX.nonce, settings);
        },
        callAJAX: function(options) {
            let defaultOptions = {
                data: {},
                method: 'POST',
                success: function(){},
                error: function(){},
            };
            options = $.extend({}, defaultOptions, options);
            const settings = {
				data: options.data,
				type: options.method,
                success: options.success,
                error: options.error
			};
            $.ajax( FX.ajaxurl, settings );
        }
    };

    FX.AddCheckoutInfo = {
        init: function() {
            $('.checkout-form').submit(function() {
                window.dataLayer.push({
                    'event': 'purchase',
                    'ecommerce': {
                        'purchase' : {
                            'actionField': {
                                'email': $("input[name='billing_email']").val(),
                                'phone': $("input[name='billing_phone']").val(),
                                'first_name': $("input[name='billing_first_name']").val(),
                                'last_name': $("input[name='billing_last_name']").val(),
                                'city': $("input[name='billing_city']").val(), 
                                'zip': $("input[name='billing_zip']").val(), 
                                'state': $("select[name='billing_state']").val()},
                        }
                    }
                });
            })
        }
    };

    return FX;
}(FX || {}, jQuery));
